import React, { ReactElement, useCallback, useMemo, useState } from "react";
import { isJioHotstarFlow } from "@swiggy-private/checkout-core";
import { CookingInstructionsFocusContext } from "@cart-client/contexts/CookingInstructionsFocusContext";
import {
    CART_ELEMENT_IDS,
    SCROLL_MARGIN_TOP_WITHOUT_BANNER,
} from "@cart-client/components/cart-renderer/constants";

export function CookingInstructionsFocusContextProvider(props: { children: React.ReactNode }): ReactElement {
    const [isCookingInstructionsFocused, setCookingInstructionsFocused] = useState(false);

    const scrollCookingInstructionsOnClick = useCallback((element: HTMLElement) => {
        if (!isJioHotstarFlow()) {
            return;
        }
        requestAnimationFrame(() => {
            const reducedMotion =
                typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
            const behavior: ScrollBehavior = reducedMotion ? "auto" : "smooth";
            const container = document.querySelector<HTMLElement>(CART_ELEMENT_IDS.CART_RENDERER_CONTAINER_SELECTOR);
            if (!container) {
                element.scrollIntoView({ behavior, block: "start", inline: "nearest" });
                return;
            }
            const containerRect = container.getBoundingClientRect();
            const elRect = element.getBoundingClientRect();
            const scrollTop =
                container.scrollTop +
                (elRect.top - containerRect.top) -
                SCROLL_MARGIN_TOP_WITHOUT_BANNER;
            container.scrollTo({ top: Math.max(0, scrollTop), behavior });
        });
    }, []);

    const cookingInstructionsFocusContextValue = useMemo(
        () => ({
            isCookingInstructionsFocused,
            setCookingInstructionsFocused,
            scrollCookingInstructionsOnClick,
        }),
        [isCookingInstructionsFocused, scrollCookingInstructionsOnClick],
    );

    return (
        <CookingInstructionsFocusContext.Provider value={cookingInstructionsFocusContextValue}>
            {props.children}
        </CookingInstructionsFocusContext.Provider>
    );
}
